import { Fragment } from "react";
import { Grid } from "@mui/material";

import { Label, TextField } from "../../../components";

export default function FormOne({ formikProps, editState }) {
  return (
    <Fragment>
      <Grid item xs={6}>
        <Label title="Company Name" />

        <TextField
          name="companyName"
          placeholder="Company Name"
          formikProps={formikProps}
          disabled={!editState || formikProps.values.gstVerified}
          required
        />
      </Grid>

      <Grid item xs={6}>
        <Label title="Company Director's Name" />

        <TextField
          name="companyDirectorsName"
          placeholder="Company Director's Name"
          formikProps={formikProps}
          disabled={!editState || formikProps.values.signAgreement}
          required
        />
      </Grid>

      <Grid item xs={6}>
        <Label title="Business Nature" />

        <TextField
          name="companyNatureBusiness"
          placeholder="Business Nature"
          formikProps={formikProps}
          disabled={!editState}
          required
        />
      </Grid>

      <Grid item xs={6}>
        <Label title="Company Address" />

        <TextField
          placeholder="Company Address"
          name="companyAddress"
          multiline
          disabled={!editState || formikProps.values.gstVerified}
          formikProps={formikProps}
          required
        />
      </Grid>

      <Grid item xs={6}>
        <Label title="Company Contact" />

        <TextField
          name="companyContact"
          placeholder="Company Contact"
          formikProps={formikProps}
          required
          disabled={!editState}
        />
      </Grid>
    </Fragment>
  );
}
